module.exports = __webpack_public_path__ + "static/img/idea1.2822d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/culture/idea1.jpg
// module id = LFti
// module chunks = 1